export default "assets/old-slider-arrow-6eea36f3.svg";